export const mutations = {
  STORE_CFS(state, cfs) {
    state.cfs = cfs;
  },
  STORE_CFS_UPDATE(state, cfsId) {
    let Cfs = state.cfs.find(function(cfs) {
      return cfs.id === cfsId;
    });
    state.systemCfs = Cfs;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/cfs/mutations.js